export enum SORT_DIRECTION {
  Asc = 'asc',
  Desc = 'desc',
}

export enum FIELD_SORTING {
  Id = 'id',
  DrawsCount = 'draws_count',
}
